import { SearchResultsPage } from '../pages/SearchResults/SearchResults.page'
import { SearchResultsRoutePathsEnum } from './searchResultsRouteConfig.types'

export const SEARCH_RESULTS_ROUTES = [
  {
    component: SearchResultsPage,
    path: SearchResultsRoutePathsEnum.SEARCH_RESULTS,
  },
]
